import CUSTOM_TYPOGRAPHY from '../../../features/theme/typography'

const TYPOGRAPHY = {
    fontSize: 12,
    fontWeight: 400,
    h1: {
        fontSize: '40px',
        ...CUSTOM_TYPOGRAPHY?.h1
    },
    h2: {
        fontSize: '32px',
        ...CUSTOM_TYPOGRAPHY?.h2
    },
    h3: {
        fontSize: '24px',
        ...CUSTOM_TYPOGRAPHY?.h3
    },
    h4: {
        fontSize: '20px',
        ...CUSTOM_TYPOGRAPHY?.h4
    },
    h5: {
        fontSize: '16px',
        ...CUSTOM_TYPOGRAPHY?.h5
    },
    h6: {
        fontSize: '14px',
        ...CUSTOM_TYPOGRAPHY?.h6
    },
    h7: {
        fontSize: '12px',
        ...CUSTOM_TYPOGRAPHY?.h7
    },
    body1: {
        fontSize: '16px',
        ...CUSTOM_TYPOGRAPHY?.body1
    },
    body2: {
        fontSize: '14px',
        fontWeight: 400,
        ...CUSTOM_TYPOGRAPHY?.body2
    },
    button: {
        fontSize: '14px',
        ...CUSTOM_TYPOGRAPHY?.button
    },
    ...CUSTOM_TYPOGRAPHY?.fontSize
}

export default TYPOGRAPHY